import { TimeTrackingSessionResource } from 'dy-frontend-http-repository/lib/modules/TimeTacking/resources';
import { createApi } from 'effector';

import { $activeTimerSession, $isActiveTimerSessionLoading, $subTicketList } from './states';

// The caller's single global timer session.
//
// Start and stop both return the authoritative session and the timer has to react instantly,
// so this is written locally. Everything the server derives — ordinal, scope summary, audit
// rows, logged totals — is refetched through `refreshSubTicketViews` rather than guessed here.
export const activeTimerSessionApi = createApi($activeTimerSession, {
    set: (_, payload: TimeTrackingSessionResource) => payload,
    clear: () => null,
});

// Puts the UI back into "restoring" before a recovery read is even issued, so there is no
// frame in which Start is offered again between a 409 and the authoritative answer.
export const activeTimerSessionLoadingApi = createApi($isActiveTimerSessionLoading, {
    beginRestore: () => true,
});

export const subTicketListApi = createApi($subTicketList, {
    // Archive committed server-side. Removing the row now makes that truth visible immediately
    // while "Show archived" is off; if the authoritative refetch then fails, the failed read is
    // simply not applied, so the row cannot reappear.
    //
    // Scoped to the Request that archived it: a mutation resolving after the user has navigated
    // away must not reach into whatever list is on screen now and delete a row out of it.
    remove: (state, { taskId, subTicketId }: { taskId: ID; subTicketId: ID }) => {
        if (state.taskId !== taskId || !state.collection) {
            return state;
        }

        return {
            ...state,
            collection: {
                ...state.collection,
                items: state.collection.items.filter((subTicket) => subTicket.id !== subTicketId),
            },
        };
    },
});
